// Task name → Meevo short report name. Same map as src/report_task_link.js.
// The owner does not type a label; the task name already names the report.

const TASK_TO_REPORT_SHORT: Record<string, string> = {
  'SUSPENDED ACCOUNTS': 'DB015 Suspended',
  'FD HOURS REPORT MES01- see info box (copy)': 'MES01 Weekly Schedules',
  'Discount Audit MR035': 'MR035 Discounts',
  'Points MR230': 'MR230 Points',
  'Refund Report': 'MR075 Refunds',
  'License/ insurance expiration report': 'DE001 Licenses',
  'New Member Emails/Calls': 'MR245 New Members',
  'Waived Payment Audit': 'DB042 Waived EFT',
  'Run discount report & email to T & C': 'MR035 Discounts',
  'Freeze Plus Report': 'DB015 Frozen',
  'NPS Report': 'ME Listens Report',
  'AQ225 - checked in/not checked out report': 'AQ225',
  'SPC Check in': '02 Service Provider Compliance',
  'Sales Closing Review/Action Plan': 'Employee Hours Sales Summary',
  'MATE- DB015': 'DB015 Frozen',
};

export function reportLabelForTask(
  definitionName?: string | null,
  locationCode?: string | null,
  storedLabel?: string | null,
): string | null {
  const stored = typeof storedLabel === 'string' ? storedLabel.trim() : '';
  if (stored) return stored;
  const name = String(definitionName || '').trim();
  const loc = String(locationCode || '').trim();
  if (!name || !loc) return null;
  const short = TASK_TO_REPORT_SHORT[name]
    || Object.entries(TASK_TO_REPORT_SHORT)
      .find(([key]) => key.toLowerCase() === name.toLowerCase())?.[1];
  return short ? `${loc} ${short}` : null;
}

/** `MELM MES01 Weekly Schedules` → `MES01 Weekly Schedules`. */
export function reportShortFromLabel(
  label?: string | null,
  locationCode?: string | null,
): string {
  const text = String(label || '').trim();
  const loc = String(locationCode || '').trim();
  if (!text) return '';
  const prefix = loc ? `${loc} ` : '';
  return prefix && text.startsWith(prefix) ? text.slice(prefix.length) : text;
}
